module.exports = __webpack_public_path__ + "static/media/logo.e61c314c.svg";